import { SEO_TITLE_SIGNUP } from 'mk/autogenerated/translations/SignupIFramePage.25f86b04e5a12aa69d323b5796415086'
import { analyticsStoreEvent } from 'mk2/actions';
import { UtmQuery } from 'mk2/apps/home/schemas';
import { SignupFormData } from 'mk2/apps/users/components/SignupForm';
import { signupTrigger, validateRegistrationInputs } from 'mk2/apps/users/containers/Signup/Signup.actions';
import { SIGNUP_FORM_NAME } from 'mk2/apps/users/containers/Signup/Signup.constants';
import signupSaga from 'mk2/apps/users/containers/Signup/Signup.sagas';
import SignupIFrame from 'mk2/apps/users/containers/SignupIFrame/SignupIFrame';
import { FormPageType } from 'mk2/constants';
import { abFetch } from 'mk2/containers/AB/AB.actions';
import { ABState } from 'mk2/containers/AB/AB.reducers';
import { getABVariant } from 'mk2/containers/AB/AB.selectors';
import { AppName } from 'mk2/containers/Application/Application';
import {
    phoneVerificationRequestToken,
    phoneVerificationVerifyToken,
} from 'mk2/containers/PhoneVerification/PhoneVerification.actions';
import { Mode } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import { PhotosUploadConfig } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { toolbarPreparePhotosUploadTrigger } from 'mk2/containers/Toolbar/Toolbar.actions';
import { cachedInitialValues } from 'mk2/helpers/form';
import { PhotoUploadStatus, SuccessfulPhotoUpload } from 'mk2/helpers/form.reducers';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { PageLayout } from 'mk2/pages/Page';
import { AppState, getRequestLastKnownUsername } from 'mk2/reducers';
import { PhotoEntity, PhotoSchema } from 'mk2/schemas';
import { getDenormalizedEntity } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { formValueSelector, getFormValues } from 'redux-form';

interface OwnProps {}

interface StateProps {
    simple: boolean;
    query: UtmQuery;
    initialValues: SignupFormData;
    currentValues: SignupFormData;
    avatar?: PhotoEntity;
}

interface DispatchProps {
    onSignup(values: SignupFormData, query: UtmQuery, iframe: boolean, newRegistrationForm: boolean);
    onStoreEvent(name: string, props: any);
    onValidateInputs(values: SignupFormData, query: UtmQuery);
    onSendSmsToken(prefix: string, phoneNumber: string, mode: Mode);
    onVerifySmsToken(token: string, mode: Mode, fullPhoneNumber: string);
    onPrepareUploadPhotos(formName: string, config: PhotosUploadConfig, files: File[], processPhotoUploadOnFormPage: FormPageType, accessKey?: string);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class SignupPageIFramePage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { location } = ownProps;
            const simple = location.pathname.split('/').indexOf('simple') >= 0;
            const query = parse(location.search);
            const username = query.username
                ? query.username.lower()
                : getRequestLastKnownUsername(state);

            const selector = formValueSelector(SIGNUP_FORM_NAME);
            const currentPhotos = selector(state, 'photos') as any[] || [];
            const avatar: PhotoEntity =
                (currentPhotos && currentPhotos.length > 0 && currentPhotos[0].status === PhotoUploadStatus.SUCCESS)
                    ? getDenormalizedEntity<PhotoEntity>(state, PhotoSchema, (currentPhotos[0] as SuccessfulPhotoUpload).photoId)
                    : null;

            return {
                avatar,
                simple,
                query,
                initialValues: cachedInitialValues(SIGNUP_FORM_NAME, {
                    username: username || '',
                    password: '',
                    email: '',
                    prefix: '',
                    phoneNumber: '',
                    token: '',
                    photos: [],
                    currentPhoto: false,
                    visibleFace: false,
                    alonePhoto: false,
                    // avatarCrop: [xPosition, yPosition, width]
                    avatarCrop: [0, 0, 100],
                }),
                currentValues: getFormValues(SIGNUP_FORM_NAME)(state) as SignupFormData,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onSignup: signupTrigger,
            onStoreEvent: analyticsStoreEvent,
            onValidateInputs: validateRegistrationInputs,
            onSendSmsToken: phoneVerificationRequestToken,
            onVerifySmsToken: phoneVerificationVerifyToken,
            onPrepareUploadPhotos: toolbarPreparePhotosUploadTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_SIGNUP;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <SignupIFrame {...props} />
        );
    }

    public getPageLayout(app: AppName, props: Props): PageLayout {
        return PageLayout.MainContentFullWidth;
    }

    public hasPageHeaderPart1(): boolean {
        return false;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public hasPageFooter(app: AppName, props: Props): boolean {
        return false;
    }

    public registerInStore(store: Store<AppState>) {
        // store.injectReducer('containers.users.signup', signupReducer);
        store.injectSaga('containers.users.signup', signupSaga);
    }
}
